module.exports = __webpack_public_path__ + "img/howto2.fc557736.png";